<template>
	<router-view :key="$route.fullPath"></router-view>
	<Footer v-if="!this.mobile"></Footer>
	<Spinner v-if="isLoading"></Spinner>
</template>

<script>
import Spinner from '@/components/Layout/Spinner';
import 'swiper/swiper.min.css';
import 'v-calendar/dist/style.css';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';
import Footer from '@/components/Layout/Footer';
import { isMobile } from '@/common/mobile';
import { mapGetters } from 'vuex';

export default {
	name: 'App',
	components: { Footer, Spinner },
	data() {
		return {
			isModalViewed: false,
			mobile: isMobile(),
		};
	},
	computed: {
		...mapGetters('common', ['isLoading']),
	},
};
</script>

<style>
@import './assets/css/common.css';
@import './assets/css/index.css';
@import './assets/css/tutorial.css';
</style>
